import { joinPaths } from "../../../util/join";
import { ScaffoldingData } from "../../ScaffoldingData";
import { ScaffoldingFileContent } from "../../ScaffoldingFile";
import { templateFile, TemplateFileOptions } from "../TemplateFile";

export function addTemplateFile(
  data: ScaffoldingData,
  fileName: string,
  content: ScaffoldingFileContent,
  options?: TemplateFileOptions,
) {
  data.files.set(
    joinPaths(data.currentDir, fileName),
    templateFile(content, options),
  );
}
